import type { ApiClient } from './client';
import type { UsageRow } from '../utils/densify';

export function createUsageApi(client: ApiClient, baseUrl: string) {
  return {
    getDaily(days: number): Promise<UsageRow[]> {
      const u = new URL(baseUrl);
      u.searchParams.set('days', String(days));
      return client.request<UsageRow[]>(u.toString(), { method: 'GET' });
    },
  };
}
